import axios from "axios"
import { showNotify } from "./Utils"

export const consultaCEP = async (cep) => {
    // verificar se cep é numerio e tem 8 digitos
    if (cep.length !== 8) {
        showNotify('warning', "CEP deve ter 8 dígitos!")
        return false
    } else if (isNaN(cep)) {
        showNotify('warning', "CEP deve ser numérico!")
        return false
    } else {
        const url = "https://viacep.com.br/ws/" + cep + "/json/"

        const resultado = await axios.get(url)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                showNotify('warning', "Erro ao buscar CEP!")
                return error
            })

        return resultado
    }
}
